module.exports = __webpack_public_path__ + "img/ar.2956b096.svg";